import { isPositiveNumber, reduce } from "et3-type-guards";

import { EFieldTone } from "../../../../../constants/enum/field-tone";
import { EUserStatus } from "../../../../../constants/enum/user-status";
import ET3Div from "../../../../../core/et3-div";
import { FIELD_GRID_EMPTY_VALUE } from "../../../../../core/et3-field-grid/field-grid-constants";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import {
  SURFACE_BORDER,
  SURFACE_HAIRLINE_COLOR,
  SURFACE_RADIUS_CSS,
  SURFACE_SHADOW
} from "../../../../../core/et3-theme/surface-constants";
import { getFirstKnownServerDate } from "../../../../../helpers/et3-date-helper";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import { ADVANCED_PAGE_WIDTH } from "../user-advanced-data-constants";
import RiskCell from "./RiskCell";
import {
  RISK_DATE_FONT_SIZE,
  RISK_VALUE_FONT_SIZE
} from "./risk-strip-constants";

const UserRiskStrip = withLiteObserverAndTheme(() => {
  const advancedStore = getUserAdvancedStore();
  const userId = advancedStore.currentUserId.get();
  const data = advancedStore.userData.get(userId);

  const temporaryBannedCount = reduce(() => data.temporaryBannedCount, 0);
  const warningCount = reduce(() => data.warningCount, 0);
  const reportsReceived = reduce(() => data.reportsReceived, 0);
  const reportsSent = reduce(() => data.reportsSent, 0);
  const userStatus = reduce(() => data.status, "");
  const isDeactivatedAccount =
    userStatus === EUserStatus.DEACTIVATED || userStatus === EUserStatus.HIDDEN;
  const deactivatedOnRaw = reduce(() => `${data.deactivatedOn}`, "");
  const deactivatedOn = isDeactivatedAccount
    ? getFirstKnownServerDate([deactivatedOnRaw])
    : FIELD_GRID_EMPTY_VALUE;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={ADVANCED_PAGE_WIDTH}
      height={0}
      fDirection="row"
      alignItems="stretch"
      justifyContent="flex-start"
      color={SURFACE_HAIRLINE_COLOR}
      style={{
        boxSizing: "border-box",
        display: "grid",
        gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
        gap: 1,
        border: SURFACE_BORDER,
        borderRadius: SURFACE_RADIUS_CSS,
        boxShadow: SURFACE_SHADOW,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      <RiskCell
        labelKey={"TEMPORARY_BANS"}
        value={`${temporaryBannedCount}`}
        valueFontSize={RISK_VALUE_FONT_SIZE}
        tone={
          isPositiveNumber(temporaryBannedCount)
            ? EFieldTone.CRITICAL
            : EFieldTone.NEUTRAL
        }
      />
      <RiskCell
        labelKey={"WARNINGS"}
        value={`${warningCount}`}
        valueFontSize={RISK_VALUE_FONT_SIZE}
        tone={
          isPositiveNumber(warningCount)
            ? EFieldTone.CRITICAL
            : EFieldTone.NEUTRAL
        }
      />
      <RiskCell
        labelKey={"REPORTS_RECEIVED"}
        value={`${reportsReceived}`}
        valueFontSize={RISK_VALUE_FONT_SIZE}
        tone={
          isPositiveNumber(reportsReceived)
            ? EFieldTone.WARNING
            : EFieldTone.NEUTRAL
        }
      />
      <RiskCell
        labelKey={"REPORTS_SENT"}
        value={`${reportsSent}`}
        valueFontSize={RISK_VALUE_FONT_SIZE}
        tone={EFieldTone.NEUTRAL}
      />
      <RiskCell
        labelKey={"DEACTIVATED_ON"}
        value={deactivatedOn}
        valueFontSize={RISK_DATE_FONT_SIZE}
        tone={EFieldTone.NEUTRAL}
      />
    </ET3Div>
  );
});
export default UserRiskStrip;
